export default "__VITE_ASSET__5b142d37__"